import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
//import "./Dashboard.css";

import { auth, db, logout, firebase_create_new_client, firebase_create_new_user, firebase_update_user_info } from "./firebase";

import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import UserDashboard from "./UserDashboard";


import { Form, Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners'


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import moment from "moment-timezone";

import Styles from './Styles'

import AsyncStorage from '@react-native-async-storage/async-storage';
import { useLocation } from "react-router-dom";

import UserInfo from "./UserInfo";
import Client from "./Client";
import ClientDevices from "./ClientDevices";
import { PropaneSharp } from "@mui/icons-material";

function Dashboard() {
  /*const [new_user, setNewUser] = useState(sessionStorage.getItem("new_user"));*/
  const uid = sessionStorage.getItem('uid');
  //console.log("DASHBOARD :: " + uid)
  const photoURL = sessionStorage.getItem('photoURL');
  const displayName = sessionStorage.getItem('displayName');
  const email = sessionStorage.getItem('email');
  const location = useLocation();

  const r = '/system_management/users/' + uid;
  //console.log(location.state.uid)

  const [user_snapshot, loading_user_snapshot, error_db] = useObject(db.ref(r));

  const history = useHistory();

  const [userInfo, setUserInfo] = useState();
  const [newUser, setNewUser] = useState();

  const [openAgree, setAgree] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);


  useEffect(() => {
    //console.log("DASHBOARD :: " + uid)
    if(uid != "")
      {
        if((user_snapshot !== undefined) && !loading_user_snapshot)
          {
            if(user_snapshot.val() !== null)
            {
              //console.log("Dashboard :: ")
              //console.log(user_snapshot.val());
              setUserInfo(user_snapshot.val());
              setNewUser("false");
              firebase_update_user_info(uid, 
                {
                  "photoURL": photoURL,
                  "displayName": displayName,
                  "last_logged_in": moment().format()
                });
              /*
              sessionStorage.setItem("new_user", "false");
              sessionStorage.setItem("email", user_snapshot.val().email);
              sessionStorage.setItem("displayName", user_snapshot.val().displayName);*/
              sessionStorage.setItem("admin", user_snapshot.val().role.admin);
              sessionStorage.setItem("power_user", user_snapshot.val().role.power_user);
              sessionStorage.setItem("sale", user_snapshot.val().role.sale);
              sessionStorage.setItem("technician", user_snapshot.val().role.technician);
              sessionStorage.setItem("user", user_snapshot.val().role.user);
              sessionStorage.setItem("manager", user_snapshot.val().role.manager);
              const storeData = async () => {
                const user_info = ["@user_info", JSON.stringify(user_snapshot.val())];
                const new_user = ["@new_user", "false"];
                try {
                  await AsyncStorage.multiSet(user_info, new_user);
                } catch (e) {
                  // saving error
                }
                //console.log("Logged in storage done.")
              }
              storeData();
            }
          }
        }
        else
          {
            //sessionStorage.setItem("new_user", "true");
            //console.log("Dashboard :: NewUser")
            setNewUser("true");
            setAgree(true);
            const storeData = async () => {
              try {
                await AsyncStorage.setItem('@new_user', "true");
              } catch (e) {
                // saving error
              }
            }
          } 
  }, [user_snapshot, loading_user_snapshot]);

  if (newUser === "creating")
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Creating user account...
              </Typography>
            </Box>
            </div>);
  }

  if(loading_user_snapshot)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
    <Box sx={{ display: 'flex' }}>
      <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
        <CircularProgress /><br />
        Checking user data...
      </Typography>
    </Box>
    </div>);
  }
  
  
  const onSubmit = async values => {
    var now = moment();
    //window.alert(JSON.stringify(values, 0, 2));
    const newClient = await firebase_create_new_client(values);
    console.log(newClient);
    setNewUser("creating");
    setOpenAdd(false);
    firebase_create_new_user(newClient, {
        "activated": "true",
        "created_at": now.format(),
        "displayName": location.state.displayName,
        "email": location.state.email,
        "photoURL": location.state.photoURL,
        "last_logged_in": now.format(),
        "last_updated": now.format(),
        "role": {
          "admin": "false",
          "manager": "false",
          "power_user": "false",
          "sale": "false",
          "technician": "false",
          "user": "true",
        }
      }).then(() => {
        //setNewUser(false);
        sessionStorage.setItem("uid", newClient);
        window.location.reload(false);
      });
  } 

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

const handleCloseAdd = () => {
    setOpenAdd(true);
  };

  const handleAgree = () => {
    setOpenAdd(true);
  };

const handleDisagree = () => {
    setAgree(false);
    logout();
  };

  const Condition = ({ when, is, children }) => (
    <Field name={when} subscription={{ value: true }}>
      {({ input: { value } }) => (value === is ? children : null)}
    </Field>
  )

  const WhenFieldChanges = ({ field, becomes, set, to }) => (
    <Field name={set} subscription={{}}>
      {(
        // No subscription. We only use Field to get to the change function
        { input: { onChange } }
      ) => (
          <OnChange name={field}>
            {value => {
              if (value === becomes) {
                onChange(to)
              }
            }}
          </OnChange>
        )}
    </Field>
  )

  const Error = ({ name }) => (
    <Field
      name={name}
      subscription={{ touched: true, error: true }}
      render={({ meta: { touched, error } }) =>
        touched && error ? <span>{error}</span> : null
      }
    />
  )

  const required = value => (value ? undefined : 'Required')


  return (
    <div className="container">  
      {
        (newUser == "true") ? (
          <Container maxWidth="xl" >
              <Grid container spacing={2} sx={{pt: 12, pl:2, pr:2, pb:2}}>
                  <Grid item xs={12}>
                  <Dialog
                      open={openAgree}
                      onClose={handleDisagree}
                      aria-labelledby="alert-dialog-title"
                      aria-describedby="alert-dialog-description"
                    >
                      <DialogTitle id="alert-dialog-title">
                        {"First time login"}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                        This is the first time logging into this system. Your logging info will be used to create user account for this smart LPG system. Only necessary information including email, uid, display name and photo's URL (if available) is required and needed to be record in our database system. The purpose of using this information is for secure login via Google authentication system in which all login processes is taken place on Google's authentication system side. You can proceed to start creating new smart LPG account if you agree with this term. Otherwise, you will be automatically logout from this system.
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={handleDisagree}>Disagree</Button>
                        <Button onClick={handleAgree} autoFocus>
                          Agree
                        </Button>
                      </DialogActions>
                    </Dialog>
                    <Dialog open={openAdd} onClose={handleCloseAdd} maxWidth={"lg"} fullWidth={true}>
                      <DialogTitle>Create New User Account</DialogTitle>
                      <DialogContent>
                      <DialogContentText>
                      Select type of user account. General user can only view status of sharing LPG devices. This type of user is normally not the owner of manager of a store. Store manager can view and share statis of registered LPG devices. This type of user account is for owner or manager of a store to deploy smart LPG devices and share them to desired users for monitoring status of LPG devices.
                      </DialogContentText>
                          <Styles>
                          <Form
                              onSubmit={onSubmit}
                              initialValues={{
                                status : { active: "true" },
                                username: location.state.email,
                                info: {
                                  displayName: location.state.displayName,
                                }
                              }}
                              render={({ handleSubmit, form, submitting, pristine, values }) => (
                                  <form onSubmit={handleSubmit}>
                                    <div>
                                      <label>User Type</label>
                                      <div>
                                        <label>
                                          <Field
                                            name="type"
                                            component="input"
                                            type="radio"
                                            value="general"
                                          />{' '}
                                          General User (can only view status of sharing LPG devices)
                                        </label>
                                        <label>
                                          <Field
                                            name="type"
                                            component="input"
                                            type="radio"
                                            value="store"
                                          />{' '}
                                          Store Manager (can view and share registered LPG devices)
                                        </label>                            
                                      </div>
                                    </div>
                                    <Condition when="type" is="store">
                                      <div>
                                        <label>Store Title</label>
                                        <Field
                                        name="info.title"
                                        component="input"
                                        type="text"
                                        placeholder="Super Mart"
                                        validate={required}
                                        />
                                        <Error name="info.title" />
                                    </div>   
                                    <div>
                                        <label>Description</label>
                                        <Field
                                        name="info.desc"
                                        component="input"
                                        type="text"
                                        placeholder="@Area 51"
                                        />
                                    </div>                  
                                    <div>
                                        <label>Street</label>
                                        <Field
                                        name="info.street"
                                        component="input"
                                        type="text"
                                        placeholder="111 High speed Rd."
                                        />
                                    </div>
                                    <div>
                                        <label>Subdistrict</label>
                                        <Field
                                        name="info.subdistrict"
                                        component="input"
                                        type="text"
                                        placeholder="Suranaree"
                                        />
                                    </div>
                                    <div>
                                        <label>District</label>
                                        <Field
                                        name="info.district"
                                        component="input"
                                        type="text"
                                        placeholder="Muang"
                                        />
                                    </div>
                                    <div>
                                        <label>Province</label>
                                        <Field
                                        name="info.province"
                                        component="input"
                                        type="text"
                                        placeholder="Nakhon Ratchasima"
                                        />
                                    </div>
                                    <div>
                                        <label>Zip Code</label>
                                        <Field
                                        name="info.postcode"
                                        component="input"
                                        type="text"
                                        placeholder="30000"
                                        />
                                    </div>
                                    </Condition>
                                    <WhenFieldChanges
                                        field="type"
                                        becomes={"general"}
                                        set="info.title"
                                        to={location.state.displayName}
                                      />
                                  <div className="buttons">
                                      <button type="submit" disabled={submitting || pristine}>
                                          Create User Account
                                      </button>
                                      <button
                                      type="button"
                                      onClick={form.reset}
                                      disabled={submitting || pristine}
                                      >
                                      Reset
                                      </button>
                                      <button
                                      type="button"
                                      onClick={logout}
                                      >
                                      Cancel
                                      </button>
                                  </div>
                                  {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
                                  </form>
                              )}
                              />
                              </Styles>
                          </DialogContent>
                      </Dialog>
                    </Grid>
              </Grid>
          </Container>
        ):(userInfo ? (<Container maxWidth="xl" >
              <Grid container spacing={2} sx={{pt: 12, pl:2, pr:2, pb:2}}>
                <Grid item xs={12} md={6} >
                  <UserInfo uid={uid} />
                </Grid>       
                <Grid item xs={12} md={6} >
                  <Client uid={uid} />
                </Grid>
                <Grid item xs={12}>
                  <ClientDevices uid={uid}/>
                </Grid>
              </Grid>
            </Container>):(<></>)
          )
        }
    </div>
  );
}

export default Dashboard;